import React, { useEffect, useRef } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Header from "../components/Header"
import Footer from "../components/Footer";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import HowItWorks from "../niches/pages/components/HowItWorks";
import Avaliacoes from "../components/Avaliacoes";
import FormularioNichos from "../niches/pages/components/FormularioNichos";



export default function DigitalInfluencerForm() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const secaoRef = useRef(null);
    const secaoRefForm = useRef(null);
    const irParaSecao = () => {
        secaoRef.current.scrollIntoView({
            behavior: "smooth",
        });
    };
    const irParaSecaoForm = () => {
        secaoRefForm.current.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <>
            <Header />
            <Box sx={{ background: "#fff", marginTop: 2 }}>
                {/* HERO */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 4, md: 14 },
                        paddingTop: { xs: 10 },
                        background: `
                            radial-gradient(
                                circle at top left,
                                rgba(156,1,185,0.12),
                                transparent 40%
                            ),
                            radial-gradient(
                                circle at bottom right,
                                rgba(30,255,134,0.10),
                                transparent 40%
                            ),
                            #FFFFFF
                        `,
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            background: "#9C01B9",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            background: "#1EFF86",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container
                        maxWidth="lg"
                        sx={{
                            position: "relative",
                            zIndex: 2,
                        }}
                    >

                        {/* ================================================= */}
                        {/* MOBILE - IMAGEM COM TEXTO POR CIMA                */}
                        {/* ================================================= */}

                        <Box
                            sx={{
                                display: { xs: "block", md: "none" },
                                position: "relative",
                                width: "100%",
                                height: { xs: 520, sm: 580 },
                                borderRadius: "28px 0 28px 0",
                                overflow: "hidden",
                                mb: 5,
                                boxShadow:
                                    "0 25px 60px rgba(0,0,0,0.18)",
                            }}
                        >

                            {/* Imagem */}
                            <Box
                                component="img"
                                src="/assets/imgMartina.jpg"
                                alt="Contabilidade para digital influencers"
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center top",
                                }}
                            />

                            {/* Overlay */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    background: `
                                        linear-gradient(
                                            to bottom,
                                            rgba(0,0,0,0.05) 0%,
                                            rgba(0,0,0,0.05) 25%,
                                            rgba(0,0,0,0.35) 55%,
                                            rgba(0,0,0,0.82) 100%
                                        )
                                    `,
                                }}
                            />

                            {/* Conteúdo sobre a imagem */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    p: { xs: 3, sm: 4 },
                                    color: "#FFF",
                                }}
                            >

                                {/* Badge */}
                                <Box
                                    sx={{
                                        display: "inline-flex",
                                        px: 1.5,
                                        py: 0.7,
                                        mb: 2,
                                        borderRadius: "999px",
                                        background:
                                            "rgba(156,1,185,0.85)",
                                        backdropFilter: "blur(10px)",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: 11,
                                            fontWeight: 800,
                                            letterSpacing: "0.04em",
                                        }}
                                    >
                                        ESPECIALISTAS EM DIGITAL INFLUENCERS
                                    </Typography>
                                </Box>

                                {/* Headline */}
                                <Typography
                                    component="h1"
                                    sx={{
                                        fontWeight: 900,
                                        lineHeight: 1.05,
                                        letterSpacing: "-0.035em",
                                        fontSize: {
                                            xs: "2.3rem",
                                            sm: "3rem",
                                        },
                                    }}
                                >
                                    Contabilidade para{" "}
                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#1EFF86",
                                        }}
                                    >
                                        Digital Influencers
                                    </Box>
                                </Typography>

                                {/* Texto */}
                                <Typography
                                    sx={{
                                        mt: 2,
                                        fontSize: "0.95rem",
                                        lineHeight: 1.5,
                                        color: "rgba(255,255,255,0.9)",
                                    }}
                                >
                                    Digital Influencer que opera no CPF paga até 27,5% de IR.
                                    Com CNPJ no Simples Nacional, você começa com 6%.
                                </Typography>

                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: { xs: "flex", md: "none" },
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                mt: -7,
                                gap: 1.5,
                            }}
                        >
                            {/* CTA PRINCIPAL */}
                            {/* <Button
                                fullWidth
                                size="large"
                                sx={{
                                    maxWidth: 420,
                                    px: 4,
                                    py: 1.8,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                    color: "#FFF",
                                    boxShadow:
                                        "0 20px 40px rgba(156,1,185,0.30)",
                                    transition: "all .3s ease",

                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow:
                                            "0 30px 60px rgba(156,1,185,0.45)",
                                    },
                                }}
                                onClick={() => {
                                    irParaSecao();
                                }}
                            >
                                Escolher meu plano
                            </Button> */}

                            {/* CTA SECUNDÁRIO */}
                            <Button
                                fullWidth
                                size="large"
                                sx={{
                                    maxWidth: 420,
                                    px: 4,
                                    py: 1.8,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",

                                    background: "#FFF",
                                    color: "#9C01B9",

                                    border: "2px solid rgba(156,1,185,0.25)",

                                    boxShadow:
                                        "0 8px 25px rgba(156,1,185,0.08)",

                                    transition: "all .3s ease",

                                    "&:hover": {
                                        transform: "translateY(-2px)",
                                        background: "rgba(156,1,185,0.04)",
                                        borderColor: "#9C01B9",
                                        boxShadow:
                                            "0 12px 30px rgba(156,1,185,0.15)",
                                    },
                                }}
                                onClick={() => {
                                    irParaSecaoForm();
                                }}
                            >
                                Falar com um contador
                            </Button>


                            {/* TRUST INDICATORS */}
                            <Stack
                                direction="row"
                                spacing={2}
                                sx={{
                                    width: "100%",
                                    maxWidth: 420,
                                    mt: 2,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                {[
                                    "Atendimento em todo Brasil",
                                    "100% Digital",
                                    "Especialistas no Nicho",
                                ].map((item, index) => (
                                    <React.Fragment key={item}>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Box
                                                sx={{
                                                    width: 9,
                                                    height: 9,
                                                    flexShrink: 0,
                                                    borderRadius: "50%",
                                                    background: "#1EFF86",
                                                    boxShadow: "0 0 12px #1EFF86",
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color: "#444",
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {item}
                                            </Typography>
                                        </Stack>

                                        {/* Separador */}
                                        {index < 2 && (
                                            <Typography
                                                sx={{
                                                    color: "#BDBDBD",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                |
                                            </Typography>
                                        )}
                                    </React.Fragment>
                                ))}
                            </Stack>
                        </Box>


                        {/* ================================================= */}
                        {/* DESKTOP - TEXTO + IMAGEM                          */}
                        {/* ================================================= */}

                        <Box
                            sx={{
                                display: { xs: "none", md: "flex" },
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 8,
                            }}
                        >

                            {/* Conteúdo */}
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    textAlign: "left",
                                }}
                            >

                                {/* Badge */}
                                <Box
                                    sx={{
                                        px: 2,
                                        py: 1,
                                        borderRadius: "999px",
                                        background:
                                            "rgba(156,1,185,0.08)",
                                        border:
                                            "1px solid rgba(156,1,185,0.15)",
                                        backdropFilter: "blur(10px)",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            fontWeight: 700,
                                            color: "#9C01B9",
                                        }}
                                    >
                                        ESPECIALISTAS EM DIGITAL INFLUENCERS
                                    </Typography>
                                </Box>

                                {/* Headline */}
                                <Typography
                                    component="h1"
                                    sx={{
                                        mt: 4,
                                        fontWeight: 900,
                                        lineHeight: 1,
                                        letterSpacing: "-0.04em",
                                        fontSize: "4.5rem",
                                        maxWidth: 700,
                                    }}
                                >
                                    Contabilidade para{" "}
                                    <Box
                                        component="span"
                                        sx={{
                                            background:
                                                "linear-gradient(90deg,#9C01B9 0%, #1EFF86 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                        }}
                                    >
                                        Digital Influencers
                                    </Box>
                                </Typography>

                                {/* Subtítulo */}
                                <Typography
                                    sx={{
                                        mt: 3,
                                        maxWidth: 650,
                                        color: "#5A5A5A",
                                        lineHeight: 1.7,
                                        fontSize: "1.2rem",
                                    }}
                                >
                                    Digital Influencer que opera no CPF paga até 27,5% de IR.
                                    Com CNPJ no Simples Nacional, você começa com 6%.
                                    A ContBlack faz essa transição em menos de 10 dias.
                                </Typography>

                                {/* CTA */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        gap: 2,
                                        mt: 4,
                                        width: "100%",
                                    }}
                                >
                                    {/* Escolher plano */}
                                    {/* <Button
                                        size="large"
                                        sx={{
                                            flex: 1,
                                            maxWidth: 250,
                                            px: 3,
                                            py: 1.8,
                                            borderRadius: "16px",
                                            fontWeight: 800,
                                            fontSize: "0.95rem",
                                            lineHeight: 1.2,
                                            whiteSpace: "nowrap",
                                            textTransform: "none",
                                            background:
                                                "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                            color: "#FFF",
                                            boxShadow:
                                                "0 20px 40px rgba(156,1,185,0.30)",
                                            transition: "all .3s ease",

                                            "&:hover": {
                                                transform: "translateY(-3px)",
                                                boxShadow:
                                                    "0 30px 60px rgba(156,1,185,0.45)",
                                            },
                                        }}
                                        onClick={() => {
                                            irParaSecao();
                                        }}
                                    >
                                        Escolher meu plano
                                    </Button> */}

                                    {/* Falar com contador */}
                                    <Button
                                        size="large"
                                        sx={{
                                            flex: 1,
                                            maxWidth: 250,
                                            px: 3,
                                            py: 1.8,
                                            borderRadius: "16px",
                                            fontWeight: 800,
                                            fontSize: "0.95rem",
                                            lineHeight: 1.2,
                                            whiteSpace: "nowrap",
                                            textTransform: "none",

                                            background: "#FFF",
                                            color: "#9C01B9",

                                            border:
                                                "2px solid rgba(156,1,185,0.25)",

                                            boxShadow:
                                                "0 8px 25px rgba(156,1,185,0.08)",

                                            transition: "all .3s ease",

                                            "&:hover": {
                                                transform: "translateY(-2px)",
                                                background:
                                                    "rgba(156,1,185,0.04)",
                                                borderColor: "#9C01B9",
                                                boxShadow:
                                                    "0 12px 30px rgba(156,1,185,0.15)",
                                            },
                                        }}
                                        onClick={() => {
                                            irParaSecaoForm()
                                        }}
                                    >
                                        Falar com contador
                                    </Button>
                                </Box>

                                {/* Trust */}
                                <Stack
                                    direction="row"
                                    spacing={3}
                                    sx={{
                                        mt: 4,
                                    }}
                                >
                                    {[
                                        "Atendimento em todo Brasil",
                                        "100% Digital",
                                        "Especialistas no Nicho",
                                    ].map((item) => (
                                        <Stack
                                            key={item}
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Box
                                                sx={{
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: "50%",
                                                    background: "#1EFF86",
                                                    boxShadow:
                                                        "0 0 12px #1EFF86",
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color: "#444",
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                }}
                                            >
                                                {item}
                                            </Typography>
                                        </Stack>
                                    ))}
                                </Stack>
                            </Box>


                            {/* Imagem desktop */}
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    position: "relative",
                                }}
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        width: 450,
                                        height: 450,
                                        borderRadius: "50%",
                                        background:
                                            "linear-gradient(135deg,#9C01B9,#1EFF86)",
                                        opacity: 0.15,
                                        filter: "blur(80px)",
                                    }}
                                />

                                <Box
                                    component="img"
                                    src="/assets/imgMartina.jpg"
                                    alt="Digital Influencer"
                                    sx={{
                                        position: "relative",
                                        zIndex: 1,
                                        width: "100%",
                                        maxWidth: 550,
                                        height: "auto",
                                        objectFit: "contain",
                                        borderRadius: "43px 0 43px 0",
                                        filter:
                                            "drop-shadow(0 30px 50px rgba(0,0,0,0.15))",
                                    }}
                                />
                            </Box>

                        </Box>

                    </Container>
                </Box>
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 8, md: 14 },
                        background: "#FFFFFF",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: { xs: 250, md: 450 },
                            height: { xs: 250, md: 450 },
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.06,
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: { xs: 250, md: 400 },
                            height: { xs: 250, md: 400 },
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.06,
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container
                        maxWidth="lg"
                        sx={{
                            position: "relative",
                            zIndex: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { xs: 5, md: 8 },
                                flexDirection: {
                                    xs: "column",
                                    md: "row",
                                },
                            }}
                        >
                            {/* ================================================= */}
                            {/* LADO ESQUERDO */}
                            {/* ================================================= */}

                            <Box
                                sx={{
                                    flex: "0 0 35%",
                                    width: "100%",
                                    textAlign: {
                                        xs: "center",
                                        md: "left",
                                    },
                                }}
                            >
                                <Typography
                                    component="h2"
                                    sx={{
                                        fontWeight: 900,
                                        lineHeight: 1.05,
                                        letterSpacing: "-0.04em",
                                        color: "#25283A",
                                        fontSize: {
                                            xs: "2.5rem",
                                            sm: "2.5rem",
                                            md: "3rem",
                                        },
                                    }}
                                >
                                    Por que continuar
                                    <br />

                                    <Box
                                        component="span"
                                        sx={{
                                            background:
                                                "linear-gradient(90deg, #9C01B9 0%, #1EFF86 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                        }}
                                    >
                                        pagando mais
                                    </Box>

                                    <br />

                                    se você pode
                                    <br />

                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#9C01B9",
                                        }}
                                    >
                                        simplificar?
                                    </Box>
                                </Typography>

                                <Typography
                                    sx={{
                                        mt: 3,
                                        maxWidth: 420,
                                        mx: {
                                            xs: "auto",
                                            md: 0,
                                        },
                                        color: "#666",
                                        fontSize: {
                                            xs: "1rem",
                                            md: "1.1rem",
                                        },
                                        lineHeight: 1.6,
                                    }}
                                >
                                    Tenha uma contabilidade feita para a realidade
                                    de quem trabalha como digital influencer, sem burocracia
                                    e sem pagar por serviços que você não precisa.
                                </Typography>
                            </Box>

                            {/* ================================================= */}
                            {/* TABELA */}
                            {/* ================================================= */}

                            <Box
                                sx={{
                                    flex: 1,
                                    width: "100%",
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    boxShadow:
                                        "0 20px 60px rgba(0,0,0,0.10)",
                                    border:
                                        "1px solid rgba(0,0,0,0.06)",
                                }}
                            >
                                {/* CABEÇALHO */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        width: "100%",
                                    }}
                                >
                                    {/* ContBlack */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            minWidth: 0,
                                            py: { xs: 2, md: 2.5 },
                                            px: { xs: 1.5, md: 3 },
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background:
                                                "linear-gradient(135deg, #9C01B9 0%, #76008D 100%)",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#FFF",
                                                fontWeight: 900,
                                                fontSize: {
                                                    xs: "1.1rem",
                                                    md: "1.5rem",
                                                },
                                            }}
                                        >
                                            ContBlack
                                        </Typography>
                                    </Box>

                                    {/* Outros */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            minWidth: 0,
                                            py: { xs: 2, md: 2.5 },
                                            px: { xs: 1.5, md: 3 },
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: "#E9E9EE",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#303344",
                                                fontWeight: 900,
                                                fontSize: {
                                                    xs: "1.1rem",
                                                    md: "1.5rem",
                                                },
                                            }}
                                        >
                                            Contabilidade tradicional
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* LINHAS */}
                                {[
                                    {
                                        contblack: "Abertura de CNPJ grátis",
                                        outros: "Abertura de empresa paga",
                                        destaque: "Abertura de CNPJ grátis",
                                    },
                                    {
                                        contblack: "Mensalidade a partir de R$ 147",
                                        outros: "Mensalidade média de R$ 500",
                                        destaque: "R$ 147",
                                    },
                                    {
                                        contblack: "Atendimento rápido e digital",
                                        outros: "Atendimento limitado e demorado",
                                        destaque: "rápido",
                                    },
                                    {
                                        contblack: "Tudo online, 24h por dia",
                                        outros: "Mais papéis e burocracia",
                                        destaque: "24h",
                                    },
                                ].map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            width: "100%",
                                            borderTop:
                                                "1px solid rgba(255,255,255,0.6)",
                                        }}
                                    >
                                        {/* CONTBLACK */}
                                        <Box
                                            sx={{
                                                flex: 1,
                                                minWidth: 0,
                                                minHeight: {
                                                    xs: 70,
                                                    md: 60,
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    md: 3,
                                                },
                                                py: 1.5,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                textAlign: "center",
                                                background:
                                                    "linear-gradient(135deg, #9C01B9 0%, #8400A0 100%)",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 600,
                                                    fontSize: {
                                                        xs: "0.85rem",
                                                        md: "1rem",
                                                    },
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                {item.contblack}
                                            </Typography>
                                        </Box>

                                        {/* OUTROS */}
                                        <Box
                                            sx={{
                                                flex: 1,
                                                minWidth: 0,
                                                minHeight: {
                                                    xs: 70,
                                                    md: 60,
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    md: 3,
                                                },
                                                py: 1.5,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                textAlign: "center",
                                                background: "#F0F1F5",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: "#303344",
                                                    fontWeight: 500,
                                                    fontSize: {
                                                        xs: "0.85rem",
                                                        md: "1rem",
                                                    },
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                {item.outros}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Container>
                </Box>
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 8, md: 12 },
                        background: "#FFFFFF",
                    }}
                >
                    {/* Glow roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.06,
                            filter: "blur(120px)",
                            top: -250,
                            left: -200,
                        }}
                    />

                    {/* Glow verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.05,
                            filter: "blur(120px)",
                            bottom: -250,
                            right: -200,
                        }}
                    />

                    <Container
                        maxWidth="lg"
                        sx={{
                            position: "relative",
                            zIndex: 2,
                        }}
                    >
                        {/* TÍTULO */}
                        <Box
                            sx={{
                                textAlign: "center",
                                mb: { xs: 5, md: 7 },
                            }}
                        >
                            <Typography
                                component="h2"
                                sx={{
                                    fontWeight: 900,
                                    letterSpacing: "-0.04em",
                                    lineHeight: 1.1,
                                    color: "#25283A",
                                    fontSize: {
                                        xs: "2rem",
                                        sm: "2.7rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Sua contabilidade{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg, #9C01B9 0%, #1EFF86 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    do seu jeito
                                </Box>
                                <Box
                                    component="span"
                                    sx={{
                                        color: "#1EFF86",
                                    }}
                                >
                                    .
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 2,
                                    mx: "auto",
                                    maxWidth: 720,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.6,
                                }}
                            >
                                Tenha tudo o que precisa para cuidar da sua empresa,
                                onde estiver e quando precisar.
                            </Typography>
                        </Box>

                        {/* CARDS */}
                        <Box
                            sx={{
                                display: "flex",
                                gap: { xs: 2, md: 1.5 },
                                flexDirection: {
                                    xs: "column",
                                    md: "row",
                                },
                                alignItems: "stretch",
                            }}
                        >
                            {[
                                {
                                    icon: "💬",
                                    titulo: "WhatsApp",
                                    texto:
                                        "Fale com um especialista sempre que precisar. Atendimento rápido, direto e sem burocracia.",
                                    imagem: '/assets/whatsCont.png',
                                },
                                {
                                    icon: "📱",
                                    titulo: "Emissor ContFácil",
                                    texto:
                                        "Acompanhe sua empresa, emita notas fiscais e tenha suas informações sempre à mão.",
                                    imagem: '/assets/contfacil.png',
                                },
                                {
                                    icon: "💻",
                                    titulo: "Plataforma",
                                    texto:
                                        "Tenha uma visão completa da sua empresa, impostos, documentos e obrigações em um só lugar.",
                                    imagem: '/assets/plataforma.png',
                                },
                            ].map((item) => (
                                <Box
                                    key={item.titulo}
                                    sx={{
                                        flex: 1,
                                        minWidth: 0,
                                        minHeight: {
                                            xs: 420,
                                            md: 430,
                                        },
                                        borderRadius: {
                                            xs: "22px",
                                            md: "18px",
                                        },

                                        background:
                                            "linear-gradient(145deg, rgba(156,1,185,0.08) 0%, rgba(30,255,134,0.05) 100%)",

                                        border:
                                            "1px solid rgba(156,1,185,0.10)",

                                        overflow: "hidden",
                                        position: "relative",

                                        display: "flex",
                                        flexDirection: "column",

                                        transition: "all .3s ease",

                                        "&:hover": {
                                            transform: {
                                                xs: "none",
                                                md: "translateY(-6px)",
                                            },

                                            borderColor:
                                                "rgba(156,1,185,0.25)",

                                            boxShadow:
                                                "0 25px 60px rgba(156,1,185,0.12)",
                                        },
                                    }}
                                >
                                    {/* CONTEÚDO */}
                                    <Box
                                        sx={{
                                            px: {
                                                xs: 3,
                                                md: 3.5,
                                            },
                                            pt: {
                                                xs: 3,
                                                md: 3.5,
                                            },
                                        }}
                                    >
                                        {/* ÍCONE + TÍTULO */}
                                        <Stack
                                            direction="row"
                                            spacing={1.5}
                                            alignItems="center"
                                        >
                                            <Box
                                                sx={{
                                                    width: 46,
                                                    height: 46,
                                                    borderRadius: "14px",

                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",

                                                    background:
                                                        "linear-gradient(135deg, rgba(156,1,185,0.15), rgba(30,255,134,0.15))",

                                                    border:
                                                        "1px solid rgba(156,1,185,0.12)",

                                                    fontSize: 22,
                                                }}
                                            >
                                                {item.icon}
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontSize: {
                                                        xs: "1.4rem",
                                                        md: "1.5rem",
                                                    },
                                                    fontWeight: 900,
                                                    color: "#25283A",
                                                }}
                                            >
                                                {item.titulo}
                                            </Typography>
                                        </Stack>

                                        {/* TEXTO */}
                                        <Typography
                                            sx={{
                                                mt: 1.5,
                                                color: "#555",
                                                fontSize: {
                                                    xs: "0.95rem",
                                                    md: "1rem",
                                                },
                                                lineHeight: 1.5,
                                                maxWidth: 400,
                                            }}
                                        >
                                            {item.texto}
                                        </Typography>
                                    </Box>

                                    {/* ÁREA DA IMAGEM */}
                                    <Box
                                        sx={{
                                            mt: "auto",
                                            width: "100%",
                                            height: {
                                                xs: 250,
                                                md: 260,
                                            },

                                            display: "flex",
                                            alignItems: "flex-end",
                                            justifyContent: "center",

                                            position: "relative",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {/* Glow atrás da imagem */}
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                width: 250,
                                                height: 250,
                                                borderRadius: "50%",
                                                background:
                                                    "linear-gradient(135deg, #9C01B9, #1EFF86)",
                                                opacity: 0.10,
                                                filter: "blur(60px)",
                                                bottom: -120,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={item.imagem}
                                            sx={{
                                                width: "140%",
                                                height: "100%",
                                                objectFit: "contain",
                                                objectPosition: "bottom",
                                                position: "relative",
                                                zIndex: 2,
                                            }}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Container>
                </Box>

                {/* DORES */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        position: "relative",
                        overflow: "hidden",
                        background: "#FAFAFA",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            background: "#9C01B9",
                            opacity: 0.05,
                            borderRadius: "50%",
                            filter: "blur(140px)",
                            top: -200,
                            right: -150,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                        letterSpacing: 1,
                                    }}
                                >
                                    PRINCIPAIS DESAFIOS
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Os problemas que mais afetam{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9,#C300E5)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    digital influencers
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    maxWidth: 750,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.8,
                                }}
                            >
                                A Lei 15.325/2026 obriga influenciadores com faturamento acima de determinados limites a terem estrutura empresarial formal. Operando no CPF ou com CNPJ inadequado, você pode receber notificação retroativa de até 5 anos, com juros de 1% ao mês e multa de até 75% sobre o valor devido.
                            </Typography>
                        </Stack>

                        {/* Cards */}
                        <Grid container
                            spacing={{ xs: 1.2, sm: 2, md: 3 }}
                            sx={{
                                justifyContent: "center",
                                width: "100%",
                                mx: "auto",
                            }}>
                            {[
                                {
                                    title: "Risco de autuação retroativa",
                                    description: "A Lei dos Influenciadores passou e você ainda não sabe o que muda para o seu CNPJ.",
                                },
                                {
                                    title: "Dificuldade para fechar contratos maiores",
                                    description: "Marcas e agências pedem nota fiscal para contratos acima de R$5.000, e você não tem como emitir.",
                                },
                                {
                                    title: "Insegurança para declarar o que recebe",
                                    description: "Você recebe do YouTube, de publis e de patrocínios mas nunca soube exatamente o que declarar.",
                                },
                                {
                                    title: "Ansiedade com cruzamento de dados da Receita",
                                    description: "Já ouviu falar que a Receita está cruzando dados de influenciadores e isso te deixa ansioso.",
                                },
                                {
                                    title: "Medo de cair na malha fina",
                                    description: "Você opera no CPF e paga alíquota máxima de IR sem perceber que existe uma alternativa legal.",
                                },
                            ].map((item, index) => (
                                <Grid
                                    item
                                    xs={6}
                                    sm={6}
                                    md={4}
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Card
                                        sx={{
                                            width: {
                                                xs: "100%",
                                                sm: "100%",
                                                md: "300px",
                                            },
                                            height: "100%",
                                            borderRadius: {
                                                xs: "16px",
                                                sm: "20px",
                                                md: "28px",
                                            },
                                            background: "rgba(255,255,255,0.8)",
                                            backdropFilter: "blur(20px)",
                                            border: "1px solid rgba(0,0,0,0.05)",
                                            boxShadow: {
                                                xs: "0 8px 25px rgba(0,0,0,0.05)",
                                                md: "0 20px 60px rgba(0,0,0,0.06)",
                                            },
                                            transition: ".35s",
                                            position: "relative",
                                            overflow: "hidden",

                                            "&:hover": {
                                                transform: {
                                                    xs: "none",
                                                    md: "translateY(-8px)",
                                                },
                                                boxShadow: {
                                                    md: "0 30px 80px rgba(156,1,185,0.12)",
                                                },
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: {
                                                    xs: 3,
                                                    md: 4,
                                                },
                                                background:
                                                    "linear-gradient(90deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: {
                                                    xs: 1.5,
                                                    sm: 2.5,
                                                    md: 4,
                                                },
                                                "&:last-child": {
                                                    pb: {
                                                        xs: 1.5,
                                                        sm: 2.5,
                                                        md: 4,
                                                    },
                                                },
                                            }}
                                        >
                                            {/* Número */}
                                            <Typography
                                                sx={{
                                                    fontSize: {
                                                        xs: "2rem",
                                                        sm: "2.8rem",
                                                        md: "4rem",
                                                    },
                                                    fontWeight: 900,
                                                    color: "rgba(156,1,185,0.08)",
                                                    lineHeight: 1,
                                                    mb: {
                                                        xs: 1,
                                                        md: 2,
                                                    },
                                                }}
                                            >
                                                0{index + 1}
                                            </Typography>

                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: {
                                                        xs: 38,
                                                        sm: 48,
                                                        md: 64,
                                                    },
                                                    height: {
                                                        xs: 38,
                                                        sm: 48,
                                                        md: 64,
                                                    },
                                                    borderRadius: {
                                                        xs: "11px",
                                                        md: "18px",
                                                    },
                                                    background:
                                                        "rgba(156,1,185,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: {
                                                        xs: 1.2,
                                                        md: 3,
                                                    },
                                                }}
                                            >
                                                <WarningAmberIcon
                                                    sx={{
                                                        color: "#9C01B9",
                                                        fontSize: {
                                                            xs: 21,
                                                            sm: 25,
                                                            md: 32,
                                                        },
                                                    }}
                                                />
                                            </Box>

                                            {/* Título */}
                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: {
                                                        xs: "0.85rem",
                                                        sm: "1rem",
                                                        md: "1.3rem",
                                                    },
                                                    lineHeight: {
                                                        xs: 1.2,
                                                        md: 1.3,
                                                    },
                                                    mb: {
                                                        xs: 0.8,
                                                        md: 2,
                                                    },
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            {/* Descrição */}
                                            <Typography
                                                sx={{
                                                    color: "#666",
                                                    fontSize: {
                                                        xs: "0.7rem",
                                                        sm: "0.8rem",
                                                        md: "1rem",
                                                    },
                                                    lineHeight: {
                                                        xs: 1.45,
                                                        md: 1.8,
                                                    },
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* BENEFÍCIOS */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#050505",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.15,
                            filter: "blur(180px)",
                            top: -250,
                            left: -250,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.08,
                            filter: "blur(180px)",
                            bottom: -250,
                            right: -250,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#1EFF86",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    A SOLUÇÃO
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    color: "#FFF",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Como a{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background: "#1EFF86",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Contblack
                                </Box>{" "}
                                ajuda você a crescer com segurança
                            </Typography>

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 750,
                                    lineHeight: 1.8,
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                }}
                            >
                                A ContBlack é especialista em influenciadores digitais. Conhecemos as particularidades da Lei 15.325/2026, sabemos quais CNAEs usar para cada tipo de conteúdo e monetização, e garantimos que sua empresa esteja em total conformidade, para que você se concentre na criação sem medo do Leão.
                            </Typography>
                        </Stack>

                        {/* Benefícios */}
                        <Grid container
                            spacing={{ xs: 1.2, sm: 2, md: 4 }}
                            sx={{
                                justifyContent: "center",
                                width: "100%",
                                mx: "auto",
                            }}>
                            {[
                                {
                                    title: "CNPJ Completo para Influenciadores",
                                    description: "CNPJ com combinação de CNAEs corretos para influenciadores, cobrindo publis, brand deals, mentorias e conteúdo.",
                                    result: "Sua empresa preparada para faturar diferentes tipos de receita sem complicações fiscais.",
                                },
                                {
                                    title: "Adequação à Lei dos Influenciadores",
                                    description: "Conformidade total com a Lei dos Influenciadores (Lei 15.325/2026).",
                                    result: "Atuação segura e alinhada às exigências legais do mercado digital.",
                                },
                                {
                                    title: "Emissão de Nota Fiscal para PJ",
                                    description: "Nota fiscal para contratos com marcas, agências e plataformas digitais.",
                                    result: "Mais credibilidade para fechar contratos com grandes empresas e parceiros.",
                                },
                                {
                                    title: "Planejamento Tributário com Fator R",
                                    description: "Redução de impostos de até 27,5% para a partir de 6% com planejamento do Fator R.",
                                    result: "Economia tributária legal que aumenta sua rentabilidade mês após mês.",
                                },
                                {
                                    title: "Recebimentos Internacionais sem Dor de Cabeça",
                                    description: "Estrutura para receber do YouTube, Patreon, plataformas internacionais com isenção fiscal.",
                                    result: "Mais dinheiro no seu bolso e menos perdas com impostos e burocracia.",
                                },
                                {
                                    title: "Declaração Segura de Todas as Receitas",
                                    description: "Declaração correta de todas as fontes de receita, sem risco de malha fina retroativa.",
                                    result: "Tranquilidade para crescer seu negócio digital sem preocupações com a Receita Federal.",
                                },
                            ].map((item, index) => (
                                <Grid
                                    item
                                    xs={6}
                                    sm={6}
                                    md={4}
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Card
                                        sx={{
                                            width: {
                                                xs: "100%",
                                                sm: "100%",
                                                md: "300px",
                                            },
                                            height: "100%",
                                            background: "rgba(255,255,255,0.04)",
                                            backdropFilter: "blur(20px)",
                                            border: "1px solid rgba(255,255,255,0.08)",
                                            borderRadius: {
                                                xs: "16px",
                                                sm: "20px",
                                                md: "28px",
                                            },
                                            position: "relative",
                                            overflow: "hidden",
                                            transition: ".35s",

                                            "&:hover": {
                                                transform: {
                                                    xs: "none",
                                                    md: "translateY(-8px)",
                                                },
                                                border: {
                                                    md: "1px solid rgba(30,255,134,0.25)",
                                                },
                                                boxShadow: {
                                                    md: "0 30px 80px rgba(30,255,134,0.08)",
                                                },
                                            },

                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                width: {
                                                    xs: 3,
                                                    md: 4,
                                                },
                                                height: "100%",
                                                background:
                                                    "linear-gradient(180deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: {
                                                    xs: 1.5,
                                                    sm: 2.5,
                                                    md: 4,
                                                },
                                                "&:last-child": {
                                                    pb: {
                                                        xs: 1.5,
                                                        sm: 2.5,
                                                        md: 4,
                                                    },
                                                },
                                            }}
                                        >
                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: {
                                                        xs: 38,
                                                        sm: 50,
                                                        md: 70,
                                                    },
                                                    height: {
                                                        xs: 38,
                                                        sm: 50,
                                                        md: 70,
                                                    },
                                                    borderRadius: {
                                                        xs: "11px",
                                                        sm: "15px",
                                                        md: "20px",
                                                    },
                                                    background:
                                                        "rgba(30,255,134,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: {
                                                        xs: 1.2,
                                                        sm: 2,
                                                        md: 3,
                                                    },
                                                }}
                                            >
                                                <CheckCircleIcon
                                                    sx={{
                                                        fontSize: {
                                                            xs: 21,
                                                            sm: 28,
                                                            md: 38,
                                                        },
                                                        color: "#1EFF86",
                                                    }}
                                                />
                                            </Box>

                                            {/* Título */}
                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 800,
                                                    fontSize: {
                                                        xs: "0.82rem",
                                                        sm: "1rem",
                                                        md: "1.35rem",
                                                    },
                                                    lineHeight: {
                                                        xs: 1.25,
                                                        md: 1.3,
                                                    },
                                                    mb: {
                                                        xs: 0.8,
                                                        sm: 1.5,
                                                        md: 2,
                                                    },
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            {/* Descrição */}
                                            <Typography
                                                sx={{
                                                    color: "rgba(255,255,255,0.7)",
                                                    fontSize: {
                                                        xs: "0.68rem",
                                                        sm: "0.8rem",
                                                        md: "1rem",
                                                    },
                                                    lineHeight: {
                                                        xs: 1.45,
                                                        md: 1.8,
                                                    },
                                                    mb: {
                                                        xs: 1.2,
                                                        sm: 2,
                                                        md: 3,
                                                    },
                                                }}
                                            >
                                                {item.description}
                                            </Typography>

                                            {/* Resultado */}
                                            <Box
                                                sx={{
                                                    borderTop:
                                                        "1px solid rgba(255,255,255,0.08)",
                                                    pt: {
                                                        xs: 1,
                                                        sm: 1.5,
                                                        md: 2,
                                                    },
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#1EFF86",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "0.65rem",
                                                            sm: "0.78rem",
                                                            md: ".95rem",
                                                        },
                                                        lineHeight: {
                                                            xs: 1.35,
                                                            md: 1.5,
                                                        },
                                                    }}
                                                >
                                                    ✓ {item.result}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>


                <div ref={secaoRefForm}>
                    <FormularioNichos nicho="Digital influencer" title="Receba uma análise através da ligação de nossos consultores para analisar e entender como solucionar o seu caso." subtitle="Após o preenchimento, fique atento ao seu celular." />
                </div>

                <HowItWorks />

                <Avaliacoes />

                {/* <div ref={secaoRef}>
                    <PlanosNichos />
                </div> */}

                {/* FAQ */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#FFFFFF",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Container maxWidth="md">
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 7 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#9C01B9",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    DÚVIDAS FREQUENTES
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Perguntas que recebemos com frequência
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    maxWidth: 700,
                                    lineHeight: 1.8,
                                }}
                            >
                                Separamos as principais dúvidas sobre contabilidade,
                                tributação e regularização para digital influencers.
                            </Typography>
                        </Stack>

                        {[
                            {
                                question: "O que muda com a Lei dos Influenciadores 2026?",
                                answer: "A lei exige enquadramento formal, CNPJ com atividades corretas e declaração de todos os rendimentos de atividade de influência digital.",
                            },
                            {
                                question: "Meu CNPJ atual está em conformidade?",
                                answer: "Depende dos CNAEs registrados. A ContBlack faz uma análise gratuita da situação atual do seu CNPJ.",
                            },
                            {
                                question: "A Receita realmente cruza dados de influenciadores?",
                                answer: "Sim. Plataformas como Google, Meta e bancos são obrigados a reportar pagamentos. A conformidade é a única proteção real.",
                            }
                        ].map((item, index) => (
                            <Accordion
                                key={index}
                                disableGutters
                                elevation={0}
                                sx={{
                                    mb: 2,
                                    borderRadius: "20px !important",
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.04)",

                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                color: "#9C01B9",
                                            }}
                                        />
                                    }
                                    sx={{
                                        minHeight: 80,
                                        px: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: {
                                                xs: "1rem",
                                                md: "1.1rem",
                                            },
                                        }}
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails
                                    sx={{
                                        px: 3,
                                        pb: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {item.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* CTA Final */}
                        <Box
                            sx={{
                                mt: 6,
                                p: 4,
                                borderRadius: "24px",
                                background:
                                    "linear-gradient(135deg, rgba(156,1,185,0.05), rgba(30,255,134,0.05))",
                                border: "1px solid rgba(156,1,185,0.08)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {
                                        xs: "1.2rem",
                                        md: "1.5rem",
                                    },
                                    mb: 1,
                                }}
                            >
                                Ainda ficou com alguma dúvida?
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    mb: 3,
                                }}
                            >
                                Converse com um especialista e receba uma orientação
                                personalizada para sua situação.
                            </Typography>

                            <Button
                                sx={{
                                    background: "#9C01B9",
                                    color: "#FFF",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "14px",
                                    fontWeight: 700,

                                    "&:hover": {
                                        background: "#83009A",
                                    },
                                }}
                                onClick={() => {
                                    if (typeof window.fbq !== "undefined") {
                                        window.fbq("trackCustom", "IniciouWhatsApp");
                                    }
                                    window.open(gerarLinkWhatsApp("Olá, gostaria de falar com um especialista sobre Digital Influencer."), '_blank')
                                }}
                            >
                                Falar com Especialista
                            </Button>
                        </Box>
                    </Container>
                </Box>
                {/* <div ref={secaoRefForm}>
                    <FormularioNichos nicho="Digital influencer" />
                </div> */}

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    );
}